import { createStore } from 'vuex'
function getUser() {
  let token = localStorage.getItem("access_token");

  if (!token) {
    return;
  }

  token = localStorage.getItem("access_token").split(".");

  if (!token) {
    return null;
  }

  let result = JSON.parse(
    decodeURIComponent(
      atob(token[1])
        .split("")
        .map(c => {
          return (
            "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
          );
        })
        .join("")
    )
  );

  // Cuando trae un solo rol se vuelve un string la propiedad, as� que lo forzamos para que sea siempre un array.
  if (typeof result.role !== 'object') {
    result.role = [result.role];
  }

  return {
    id: result.id,
    roles: result.role,
    name: result.nombre,

  };
}
export default createStore({
  state: {
    user: null,
    items: null,
    fechas : null,
    avatar: 'https://res.cloudinary.com/dnnwjfm9m/image/upload/v1695077644/avatar_default_ajfkhn_bjrofo.webp',
    isAppMobile: false,
    opNotas: '',
    nameCourse: 'Course',
    imgs: 'https://res.cloudinary.com/dnnwjfm9m/image/upload/v1695077644/avatar_default_ajfkhn_bjrofo.webp',
    themas : 1,
    rutaSR : 'https://ucam.uelibertad.online/' //  http://localhost:3000/  https://uecam.online/
  },
  getters: {
    user: (state) => {
      if (!state.user) {
        return getUser();
      }

      return state.user;
    },
    getMyState: state => state.themas
  },
  mutations: {
    signIn(state) {
      state.user = getUser();
    },
    agregar2: function (state, { img }) {
      state.avatar = img;
    },
    upCourse: function (state, { course }) {
      state.nameCourse = course
    },
    upMenuNotas: function (state, { setOpNotas }) {
      state.opNotas = setOpNotas
    },
    updatepx: function (state, { estado }) {
      state.isAppMobile = estado;
    },
    sendItems: function (state, { item }) {
      state.items = item;
    },
    sendFechas: function (state, { fecha }) {
      state.fechas = fecha;
    },
    updateThemes: function (state, { thema }) {
      state.themas = thema;
    },
  },
  actions: {
  },
  modules: {
  }
})
